import React from "react";
import { History } from "lucide-react";
import { Tile, Badge } from "../Primitives";
import { relTime } from "../apikeys/shared";
import { actorName } from "./util";

const ACTION = { hidden: ["critical", "Hidden"], shown: ["success", "Shown"], preset: ["info", "Pilot preset"] };

export default function VisibilityHistory({ events }) {
  return (
    <Tile testid="module-history" dense
          title={<span className="text-[11px] font-semibold tracking-widest uppercase text-muted inline-flex items-center gap-2"><History size={12} className="text-primary" /> Change history</span>}
          action={events && <span className="text-[10px] text-subtle font-mono-tabular">{events.length} events</span>}>
      {events?.length === 0 && <div data-testid="module-history-empty" className="p-6 text-center text-[12px] text-muted">No changes yet.</div>}
      {events?.length > 0 && (
        <div className="overflow-x-auto max-h-[420px] overflow-y-auto">
          <table className="w-full text-[11.5px]">
            <thead className="sticky top-0 bg-surface">
              <tr className="text-[10px] uppercase tracking-widest text-subtle border-b border-border">
                <th className="text-left font-semibold px-4 py-2">When</th>
                <th className="text-left font-semibold px-4 py-2">Action</th>
                <th className="text-left font-semibold px-4 py-2">Modules</th>
                <th className="text-left font-semibold px-4 py-2">Reason</th>
                <th className="text-left font-semibold px-4 py-2">By</th>
              </tr>
            </thead>
            <tbody>
              {events.map(e => {
                const [status, label] = ACTION[e.action] || ["neutral", e.action];
                return (
                  <tr key={e.id} data-testid={`module-history-row-${e.id}`} className="border-b border-border/60 align-top hover:bg-surface-2/50">
                    <td className="px-4 py-2 font-mono-tabular text-muted whitespace-nowrap" title={e.ts}>{relTime(e.ts)}</td>
                    <td className="px-4 py-2"><Badge status={status}>{label}</Badge></td>
                    <td className="px-4 py-2 min-w-[180px]">{(e.labels || e.modules).join(", ")}</td>
                    <td className="px-4 py-2 text-muted min-w-[240px]">{e.reason}</td>
                    <td className="px-4 py-2 whitespace-nowrap">{actorName(e.actor)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Tile>
  );
}
